"use client";

import { c as _c } from "react/compiler-runtime";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { classNames } from "@/lib/utils";
type ButtonProps = React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>;
export function Button(t0) {
  const $ = _c(13);
  let children;
  let className;
  let disabled;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      disabled,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = disabled;
    $[4] = props;
  } else {
    children = $[1];
    className = $[2];
    disabled = $[3];
    props = $[4];
  }
  const t1 = disabled ? "cursor-not-allowed bg-[#f5f5f5] text-[#141414]/30 focus:ring-[#f5f5f5]" : "cursor-pointer bg-[#141414] text-white hover:bg-[#141414]/90 active:scale-[0.99] focus:ring-[#141414]/20";
  let t2;
  if ($[5] !== className || $[6] !== t1) {
    t2 = classNames("focus:outline-hidden w-full rounded-[16px] px-4 py-3.5 text-[15px] font-semibold transition-colors duration-150 focus:ring-2 focus:ring-offset-2", t1, className);
    $[5] = className;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== children || $[9] !== disabled || $[10] !== props || $[11] !== t2) {
    t3 = <button disabled={disabled} className={t2} {...props}>{children}</button>;
    $[8] = children;
    $[9] = disabled;
    $[10] = props;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  const buttonElement = t3;
  return buttonElement;
}